import React, { Component } from 'react';
import { ForgeIconButton, ForgeIcon } from '@tylertech/forge-react';

export interface PanelHeaderProps {
  onClosePanel: () => void;
  panelHeaderText: string;
}

class PanelHeader extends Component<PanelHeaderProps> {
  focusSettingsButton = () => {
    const settingButton = document.querySelector('.setting-button') as HTMLElement;
    if (settingButton) {
      settingButton.focus();
    }
  };

  render() {
    const { onClosePanel, panelHeaderText } = this.props;

    return (
      <div className="notification-panel-header">
        <div className="header-text forge-typography--heading3" data-testid="panel-header-text">
          {panelHeaderText}
        </div>
        <ForgeIconButton
          className="close-panel-link close-notifications-panel-link"
          onClick={onClosePanel}
          aria-label="Close Notification"
        >
          <ForgeIcon name="close"></ForgeIcon>
        </ForgeIconButton>
      </div>
    );
  }
}

export default PanelHeader;
